import { render, staticRenderFns } from "./OleMissBufferPostlabQuestion3.vue?vue&type=template&id=3e0f799e&"
import script from "./OleMissBufferPostlabQuestion3.vue?vue&type=script&lang=ts&"
export * from "./OleMissBufferPostlabQuestion3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VTextarea})
